<template>
  <section
    v-if="props.data"
    class="cta-section center-align"
    :class="[ props.data.parentClasses, props.data.parentStyle ? props.data.parentStyle : 'defaultStyle' ]"
  >
    <div class="container parallax-container__content">
      <h2 class="title">
        {{ props.data.parallax.title }}
      </h2>

      <span class="parallax-container__content__timeStripe row justify-center">
        <div class="col s12 m10 l8 flex justify-center">
          <HelpersTimeStripe 
            v-if="props.data.timeStripeEnable && !props.options.settingsData.is_quote_only"
            :data="estShipDate"
          />
        </div>
      </span>

      <div class="btn-holder row justify-center">
        <div class="col s12 m10 l8">
          <PagesProductActionsForm
            :data="{
              actionBtns: props.data.actionBtns,
              startUpMaxOrderQty: props.options.settingsData.is_quote_only ? props.options.settingsData.quantity.quote_min_quantity : props.options.settingsData.quantity.order_min_quantity,
              productOrderMax: props.data.parallax.product_order_max
            }"
            :product-spec-data="props.productSpecData"
            :product-data="props.productData"
            :options="props.options"
            @return-for-gtm="e => {
              emit('returnForGtm', e)
            }"
          />
        </div>
      </div>
    </div>
    <div
      v-if="props.data.parallax.image.original"
      class="parallax"
    >
      <NuxtPicture
        loading="lazy"
        preload
        :img-attrs="{class: 'responsive-img', alt: props.data.parallax.image.text}"
        :src="props.data.parallax.image.original"
        :placeholder="[100]"
        height="600"
        width="1980"
      />
    </div>
  </section>
</template>

<script setup>
const estShipDate = ref(false)

/**
* Props
*/
const props = defineProps({
  data: {
    type: [Object],
    default: null
  },
  productData: {
    type: [Object],
    default: null
  },
  productSpecData: {
    type: [Object],
    default: null
  },
  options: {
    type: [Object],
    default: null
  }
})

/**
* Emits
*/
const emit = defineEmits(['returnForGtm'])

/**
* Get Est Ship Date
*/
watch(useInterval(1000), () => {
  if (props.options.globalData && props.options.settingsData) {
    estShipDate.value = getEstShipDate({
      cutOffTime: props.options.globalData.cut_off_time,
      timeRestriction: props.productData.delivery_time_list.min,
      timeRestrictionsArr: props.productData.delivery_time_list,
      isShort: true
    })
  }
})
</script>

<style lang="scss" scoped>
.parallax-container {
  display: flex;
  align-items: center;
  height: 60vh;
  max-height: 600px;
  @media only screen and (max-width: 600px) {
    height: auto;
    min-height: 35vh;
  }
  &:before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    background: $paralax-overflow-color;
  }
  &__content {
    position: relative;
    z-index: 1;
    color: #fff;
    .title {
      color: #fff;
    }

    &__timeStripe {
      &:deep(.time-stripe) {
        width: max-content;
        padding: .5rem 1.25rem;
        margin-bottom: 0;
        margin-bottom: 1.25rem;
        color: #fff;
        font-size: 11px;
        line-height: 1.5;
        background-color: rgba(8,8,18,.2);
        border-radius: 60px;
        i {
          color: #fff;
          font-size: 1.25rem;
          vertical-align: sub;
          @media only screen and (min-width: 993px) {
            margin-right: .25rem;
            font-size: 1.1875rem;
          }
        }
        time {
          font-weight: 700;
        }
      }
    }

    &:deep(.cta-form) {
      justify-content: center;
      .btn-holder {
        flex: 0 1 auto !important;
        // .btn {
        //   min-width: inherit!important;
        //   max-width: max-content;
        //   margin: 0 auto;
        // }
      }

      @media only screen and (max-width: 600px) {
        margin: 1rem 0 0 0;
      }

      .cta-block-item {
        justify-content: center;
      }
    }
  }
  .parallax {
    &:deep(img) {
      @media only screen and (min-width: 993px) {
        width: auto;
        max-width: fit-content;
        min-height: 100%;
        max-height: 125%;
      }
    }
  }

  /*
  * Second Style
  */
  &.secondStyle {
    &:deep(.cta-form) {
      & > .cta-block-item {
        .btn-separate {
          font-size: 1rem;
          text-transform: uppercase;
        }
      }
    }
  }
}
</style>
